import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';

import { questionAnswered } from 'actions/questionnaires';
import { Mode } from 'common/questionnaires/types';

const QuestionCheckboxField = ({ id, name, isForm, answer, mode, dispatch }) => {
  const handleChange = (event) => {
    if (event && event.target) {
      dispatch(questionAnswered({ id, answer: event.target.checked, mode, isForm, name }));
    }
    if (name === 'subjectToBackupWhd') {
      const initialise = { certification: { subjectToBackupWithholding: event.target.checked } };
      dispatch(initialize('w9-form', initialise));
    }
  };

  return (
    <div className="single-inline-checkbox">
      <label className="form-checkbox">
        <input
          id={ id }
          name={ id }
          type="checkbox"
          checked={ answer }
          onChange={ handleChange }
          value={ answer }
        />
        <i className="form-icon" />
      </label>
    </div>
  );
};

QuestionCheckboxField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  isForm: PropTypes.bool,
  answer: PropTypes.bool,
  mode: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
};

QuestionCheckboxField.defaultProps = {
  isForm: false,
  answer: false,
  name: null
};

const mapDispatchToProps = dispatch => ({ dispatch });

const mapStateToProps = (state) => {
  const {
    app: { onlineConfig },
  } = state;

  return {
    mode: (onlineConfig && onlineConfig.preQualifyingQuestionnaireMode) ? onlineConfig.preQualifyingQuestionnaireMode : Mode.Crs
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionCheckboxField);
